import Vue from 'vue'
import App from './App.vue'

import 'foundation-sites/css/foundation.min.css';

Vue.config.productionTip = false

new Vue({
  el: '#wordpress-kba-tool',
  render: h => h(App),
});
